import React, { useState } from "react";
import { Alert, Button, Form, Input, Select, Space, message } from "antd";
import useAuthenthication from "../../hooks/useAuthentication";
import { useI18n } from "../../i18n/I18nContext";
import { Locale } from "../../i18n/messages";

interface IAuthProps {
  email: string;
  password: string;
  tokenFromFlashDrive: string;
}

const LoginPage: React.FC = () => {
  const { isLoading, signInCall } = useAuthenthication();
  const { t, locale, setLocale } = useI18n();
  const [error, setError] = useState<string>();
  const [flashDriveToken, setFlashDriveToken] = useState("");

  const showError = (text: string) => {
    setError(text);
    message.error(text, 8);
  };

  const onFinish = async (values: IAuthProps) => {
    setError(undefined);
    if (!flashDriveToken) {
      showError(t("login.tokenRequired"));
      return;
    }
    try {
      await signInCall({ ...values, tokenFromFlashDrive: flashDriveToken });
    } catch (err: any) {
      const code = err?.code || err?.response?.data?.code;
      const msg = err?.message || err?.response?.data?.message;
      if (code === "INVALID_TOKEN" || msg === "Неверный токен доступа") {
        showError(t("login.invalidToken"));
      } else if (
        code === "INVALID_CREDENTIALS" ||
        msg === "Неверный логин или пароль"
      ) {
        showError(t("login.invalidCredentials"));
      } else {
        showError(
          typeof msg === "string" && msg ? msg : t("login.error")
        );
      }
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (event: any) {
        setFlashDriveToken(event.target.result);
      };
      reader.readAsText(file);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <Space style={{ position: "absolute", top: 24, right: 24 }}>
        <Select
          value={locale}
          style={{ width: 140 }}
          onChange={(v: Locale) => setLocale(v)}
          options={[
            { value: "ru", label: t("lang.ru") },
            { value: "ro", label: t("lang.ro") },
          ]}
        />
      </Space>

      {error && (
        <Alert
          type="error"
          message={error}
          style={{ maxWidth: 420, width: "100%" }}
          showIcon
          closable
          onClose={() => setError(undefined)}
        />
      )}

      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 480, width: "100%" }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={t("login.email")}
          name="email"
          rules={[{ required: true, message: t("login.emailRequired") }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t("login.password")}
          name="password"
          rules={[{ required: true, message: t("login.passwordRequired") }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item label={t("login.token")} name="flashDriveFile">
          <Input type="file" onChange={handleFileChange} />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {t("login.submit")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginPage;
